var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSinkBathroom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 112,
    viewBox: "0 0 65 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 7,
    height: 29,
    x: 29,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 6,
    height: 28,
    x: 29.5,
    y: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M34.5 19c1.667-.796 2.5-1.685 2.5-2.667 0-.982-.833-2.76-2.5-5.333-1.667 2.574-2.5 4.351-2.5 5.333 0 .982.833 1.871 2.5 2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M34.5 18.443c1.363-.69 2-1.403 2-2.11 0-.773-.666-2.264-2-4.401-1.334 2.137-2 3.628-2 4.401 0 .707.637 1.42 2 2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M43 17h3v9h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M43.5 17.5h2v8h-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 14,
    height: 5,
    x: 40,
    y: 15,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 13,
    height: 4,
    x: 40.5,
    y: 15.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M19 17h3v9h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M19.5 17.5h2v8h-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 14,
    height: 5,
    x: 11,
    y: 15,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 13,
    height: 4,
    x: 11.5,
    y: 15.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M24.918 54.2C12.494 51.42 3.214 41.7 2.712 30h59c-.491 11.448-9.387 21.001-21.41 24.012L45.118 112h-25l4.8-57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M20.661 111.5h23.914l-4.806-57.87.412-.103C51.983 50.57 60.467 41.335 61.184 30.5H3.24c.734 11.091 9.603 20.485 21.788 23.212l.425.096L20.66 111.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 65,
    height: 7,
    y: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 64,
    height: 6,
    x: 0.5,
    y: 24.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 11,
    height: 4,
    x: 27,
    y: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 10,
    height: 3,
    x: 27.5,
    y: 9.5,
    rx: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSinkBathroom);
export default __webpack_public_path__ + "static/media/RoomSinkBathroom.3f3ed23245c69715a6230216e67a3300.svg";
export { ForwardRef as ReactComponent };